class BillingDelegate {
    handleDateChange(dates) {
        this.setState({ dateRange: dates });
        if (dates && dates.length === 2) {
            // Reload data with new date range
            this.loadDataWithDateRange(dates[0], dates[1]);
        }
    }

    handleSelectStatement(statementId) {
        const selectedStatements = new Set(this.state.selectedStatements);
        if (selectedStatements.has(statementId)) {
            selectedStatements.delete(statementId);
        } else {
            selectedStatements.add(statementId);
        }
        this.setState({ selectedStatements });
    }

    handleSelectAll() {
        const { statements } = this.state;
        if (this.state.selectedStatements.size === statements.length) {
            this.setState({ selectedStatements: new Set() });
        } else {
            this.setState({ selectedStatements: new Set(statements.map(s => s.id)) });
        }
    }
}

export default BillingDelegate;

